import React, { Component, Fragment } from 'react';
import Sidebar from '../navigation/Sidebar';
import { Link } from 'react-router-dom';
import Rest from "../../services/Rest";
import { withRouter } from "react-router-dom";

class CampDetail extends Component {

    constructor(props) {
        super(props);
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = {
        campana: [],
        error: false,
        messageError: ""
    }

    componentDidMount() {

        this.Rest.get("campanas/" + this.props.match.params.id, this.datauser)
            .then(response => {
                //console.log(response.data);
                if (response.status === 200) {
                    this.setState({
                        campana: response.data.campana
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: response.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    messageError: "Error de red"
                })
            });
    }


    render() {

        const { campana, error, messageError } = this.state;

        return (
            <Fragment>
                {error ? <div className="alert alert-danger alert-float">{messageError}</div> : null}
                <div className="wrapper">
                    <Sidebar logout={() => this.props.callBackLogout()} />
                    <div id="content">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="dashboard-panel">
                                        <h4 className="mb-center">Detalle de la campaña</h4>
                                        <table className="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td colSpan="2" className="bg-primary">
                                                    <p className="text-center text-white">Nombre de la campaña</p>
                                                    <h3 className="text-center text-white">{campana.nombre}</h3></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2">
                                                        <ul className="list-unstyled">
                                                            <li>
                                                                <p>
                                                                    <b className="text-primary">Fecha y hora de inicio de la campaña</b>
                                                                </p>
                                                                <p>{campana.fechaInicio} a las {campana.horaInicio}</p>
                                                            </li>
                                                            <li className="divider">
                                                                <hr />
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    <b className="text-primary">Fecha y hora de finalización de la campaña</b>
                                                                </p>
                                                                <p>{campana.fechaFinalizacion} a las {campana.horaFinalizacion}</p>
                                                            </li>
                                                            <li className="divider">
                                                                <hr />
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    <b className="text-primary">Disponible los siguientes días</b>
                                                                </p>
                                                                <ul className="list-inline">
                                                                    {typeof campana.dias !== "undefined" ? campana.dias.map((dia, index) => (
                                                                        <li key={index} className="list-inline-item badge badge-secondary">{dia}</li>
                                                                    )) : null}
                                                                </ul>
                                                            </li>
                                                            <li className="divider">
                                                                <hr />
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    <b className="text-primary">Mensaje</b>
                                                                </p>
                                                                <p className="text-justify">{campana.mensaje}</p>
                                                            </li>

                                                            <li>
                                                                <p>
                                                                    <b className="text-primary">No. de reintentos</b>
                                                                </p>
                                                                <p className="text-justify">{campana.numReintentos}</p>
                                                            </li>
                                                            <li>
                                                                <p>
                                                                    <b className="text-primary">Estado de la campaña</b>
                                                                </p>
                                                                {campana.habilitarCamp === "0" ? <span className="badge badge-pill badge-danger">Deshabilitada</span> : <span className="badge badge-pill badge-success">Habilitada</span>}
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="bg-primary" colSpan="2">
                                                        <h3 className="text-center text-white">Datos CSV</h3>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="2">
                                                    {typeof campana.datoscsv !== "undefined" ?
                                
                                <table className="table table-bordered table-condensed table-striped">
                                    <tbody>
                                        {campana.datoscsv.map((datos, index) => (
                                            <tr key={index}>
                                                <td>{datos[0] ? datos[0] : datos.campo}</td>
                                                <td>{datos[1] ? datos[1] : datos.valor}</td>
                                                <td>{datos[2] ? datos[2] : datos.valor}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            
                            :
                            null}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="bg-primary" colSpan="2">
                                                    <h3 class="text-center text-white">Respuestas automatizadas</h3>
                                                    </td>
                                                </tr>
                                                {campana.respuestas ? campana.respuestas.map((val, index)=>(
                                                    <tr key={index}>
                                                        <td colSpan="2">
                                                            <p>Palabra clave: <b>{val.clave}</b></p>
                                                            <p>Respuesta: <b>{val.respuesta}</b></p>
                                                            <hr/>
                                                        </td>
                                                    </tr>
                                                )): <div className="alert alert-warning">Esta campaña no cuenta con respuestas automatizadas</div>}
                                            </tbody>
                                        </table>





                                        <Link to="/lista-de-campañas" className="btn btn-secondary">
                                            Volver a campañas
                                                </Link>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withRouter(CampDetail);


// WEBPACK FOOTER //
// ./src/components/campaigns/CampDetail.js